import { render, staticRenderFns } from "./WheelLockController.vue?vue&type=template&id=504825e4&"
import script from "./WheelLockController.vue?vue&type=script&lang=js&"
export * from "./WheelLockController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports